import { createRoute } from '@tanstack/react-router';
import { BundlePage } from '@/features/bundles/bundle-page.js';
import { authenticatedRoute } from './authenticated.js';

/** `/bundles/$sku` — fiche d'un bundle (`02` §8) : composition, statut, test. */
export const bundleDetailRoute = createRoute({
  getParentRoute: () => authenticatedRoute,
  path: '/bundles/$sku',
  component: BundlePage,
});
